import { WebSocketCodes } from './websocket-codes.ts';

/**
 * Used to determine if a client should attempt to reconnect after a socket
 * connection has been closed.
 *
 * @description If on reconnect a user would 'recover' a connection and continue
 * to successfully collaborate on a board, they should reconnect.
 * @description If no matter how many times a user attempts to reconnect they
 * will fail to, a user-facing message should be displayed, and they should not
 * be able to reconnect.
 *
 * @param code
 * @returns
 */
export function shouldClientReconnect(code: WebSocketCodes) {
  switch (code) {
    case WebSocketCodes.CLIENT_ERROR:
    case WebSocketCodes.EXCEPTION_CLOSURE:
    case WebSocketCodes.NORMAL_CLOSURE:
    case WebSocketCodes.SESSION_FULL:
    case WebSocketCodes.SESSION_REVOKED:
    case WebSocketCodes.SESSION_LOCKED:
    default:
      return true;
    case WebSocketCodes.SESSION_NEEDS_UPDATE:
    case WebSocketCodes.SESSION_ARCHIVED:
    case WebSocketCodes.SESSION_DELETED:
      return false;
  }
}
